import { defineMessages } from 'react-intl';

export const closedMessageMessages = defineMessages({
	content: {
		id: 'message.close.content',
		defaultMessage:
			'Thank you for using our service.<br/>We hope to see you again soon!',
		description: 'Content text displayed in the close screen',
	},
});
